import { SvgIconProps } from "@mui/material";
import { FC } from "react";

export const Logo: FC<SvgIconProps> = ({ width = 48, height = 48, fill = "#009DDE", ...rest }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox={"0 0 48 48"}
            fill={"none"}
            xmlns={"http://www.w3.org/2000/svg"}
            {...rest}
        >
            <path
                d={
                    "M19.0809 14.4194L19.6113 17.1366H24.1728L24.156 17.184L18.6301 33.6926H28.4758L27.8298 30.7999H22.8288L22.8448 30.754L28.179 14.4194H19.0809Z"
                }
                fill={"url(#paint0_radial_46_893)"}
            />
            <path
                fillRule={"evenodd"}
                clipRule={"evenodd"}
                d={
                    "M11.0812 19.3076H15.7687C17.6902 19.3076 19.3044 20.9227 19.3044 22.8461C19.3044 24.7663 17.6902 26.4294 15.7687 26.4294C15.6135 26.4294 14.0788 26.4275 14.0788 26.4275H14.0439V28.6733H11.4145V21.5211L11.0812 19.3076ZM14.0788 24.3549L15.5347 24.3519C16.2718 24.3519 16.9218 23.6492 16.922 22.9079C16.922 22.1712 16.2718 21.5231 15.5347 21.5231L14.0788 21.5258H14.0439V24.3549H14.0788Z"
                }
                fill={"url(#paint1_radial_46_893)"}
            />
            <path
                d={
                    "M34.1142 24.8667C34.1142 25.7411 33.3997 26.3996 32.585 26.3996C31.7703 26.3996 31.0564 25.7411 31.0564 24.8667C31.0564 24.7921 31.0592 19.5965 31.0598 19.0864L28.405 19.5169V24.7415C28.405 27.0902 30.2975 28.9304 32.5852 28.9304C34.8729 28.9304 36.7659 27.0904 36.7659 24.7415V19.0866L34.1083 19.5172C34.1088 19.9451 34.1142 24.7957 34.1142 24.8667V24.8667Z"
                }
                fill={"url(#paint2_radial_46_893)"}
            />
            <path
                fillRule={"evenodd"}
                clipRule={"evenodd"}
                d={
                    "M0 23.9791C0 10.76 10.7564 0.0027489 23.978 0C37.1951 0.00253744 47.9499 10.76 47.9516 23.9791C47.9499 37.1973 37.1954 47.9516 23.978 47.9516C10.7564 47.9516 0 37.1973 0 23.9791ZM7.11669 23.9771C7.13297 33.2576 14.6969 40.8209 23.9784 40.8351C33.2547 40.8207 40.8171 33.2576 40.8372 23.9771C40.8173 14.6971 33.2547 7.13337 23.9784 7.11688H23.978C14.6971 7.13337 7.13297 14.6971 7.11669 23.9771Z"
                }
                fill={"url(#paint3_radial_46_893)"}
            />
            <defs>
                <radialGradient
                    id={"paint0_radial_46_893"}
                    cx={"0"}
                    cy={"0"}
                    r={"1"}
                    gradientUnits={"userSpaceOnUse"}
                    gradientTransform={"translate(9.83469 8.64033) scale(44.6269 87.358)"}
                >
                    <stop stopColor={"#84D0F0"} />
                    <stop offset={"0.15"} stopColor={"#00A8E4"} />
                    <stop offset={"0.333"} stopColor={"#0078BE"} />
                    <stop offset={"0.5"} stopColor={"#00509E"} />
                    <stop offset={"1"} stopColor={"#001C54"} />
                </radialGradient>
                <radialGradient
                    id={"paint1_radial_46_893"}
                    cx={"0"}
                    cy={"0"}
                    r={"1"}
                    gradientUnits={"userSpaceOnUse"}
                    gradientTransform={"translate(10.0333 8.63923) scale(44.2719 50.4228)"}
                >
                    <stop stopColor={"#84D0F0"} />
                    <stop offset={"0.15"} stopColor={"#00A8E4"} />
                    <stop offset={"0.333"} stopColor={"#0078BE"} />
                    <stop offset={"0.5"} stopColor={"#00509E"} />
                    <stop offset={"1"} stopColor={"#001C54"} />
                </radialGradient>
                <radialGradient
                    id={"paint2_radial_46_893"}
                    cx={"0"}
                    cy={"0"}
                    r={"1"}
                    gradientUnits={"userSpaceOnUse"}
                    gradientTransform={"translate(10.0335 8.54561) scale(44.3462 52.2128)"}
                >
                    <stop stopColor={"#84D0F0"} />
                    <stop offset={"0.15"} stopColor={"#00A8E4"} />
                    <stop offset={"0.333"} stopColor={"#0078BE"} />
                    <stop offset={"0.5"} stopColor={"#00509E"} />
                    <stop offset={"1"} stopColor={"#001C54"} />
                </radialGradient>
                <radialGradient
                    id={"paint3_radial_46_893"}
                    cx={"0"}
                    cy={"0"}
                    r={"1"}
                    gradientUnits={"userSpaceOnUse"}
                    gradientTransform={"translate(10.0328 8.64057) scale(44.2706)"}
                >
                    <stop stopColor={"#84D0F0"} />
                    <stop offset={"0.15"} stopColor={"#00A8E4"} />
                    <stop offset={"0.333"} stopColor={"#0078BE"} />
                    <stop offset={"0.5"} stopColor={"#00509E"} />
                    <stop offset={"1"} stopColor={"#001C54"} />
                </radialGradient>
            </defs>
        </svg>
    );
};
